import { selectActiveEntity, selectAllEntities } from '@ngneat/elf-entities';
import { selectRequestStatus } from '@ngneat/elf-requests';
import { map } from 'rxjs/operators';

import { sortByUlid } from '~shared/helpers';

import { cuttingListStore } from './cutting-lists.store';

export const cuttingListsSelector = {
	cuttingLists$: cuttingListStore.pipe(selectAllEntities(), map(sortByUlid)),
	cuttingListsLoading$: cuttingListStore.pipe(selectRequestStatus('get-cutting-lists'), map((status) => status.value === 'pending')),
	cuttingListUpdateLoading$: cuttingListStore.pipe(selectRequestStatus('update-cutting-list'), map((status) => status.value === 'pending')),
	activeCuttingList$: cuttingListStore.pipe(selectActiveEntity()),
};